import simpleParallax from "simple-parallax-js";
import {Youtube} from "./Youtube";

export class CrossCurricurum {
	
	static VIDEO_MV_PC = {
		id: 'Z-bflVUtFpk',
		width: 1000,
		height: 840
	};
	static VIDEO_MV_SP = {
		id: 'E69XezeFLpo',
		width: 1246,
		height: 1920
	};
	
	// static VIDEO_LABO_ID = 'Fu931oDBMik';
	
	constructor(app) {
		this.app = app;
		this.initVideo();
		this.initSlider();
		this.initScroll()
		this.initOpen();
		this.initAnimation();
	}
	initVideo() {
		if(window.isYoutubeAccess){
			this.initYoutube();	
		}else{
			this.initMp4();		
		}
	}
	initYoutube() {
		Youtube.initTag(this.onReadyYoutube.bind(this));
	}

	onReadyYoutube() {
		this.initMvYoutube();
		// this.initLaboYoutube();
	}
	
	initMp4(){
		this.initMp4Mv();
		this.initMp4Labo();
	}
	
	initMp4Mv(){
		var video = document.querySelector('#mvVideoMp4');
		video.play();
		video.classList.add('is-active');
	}
	initMp4Labo(){
		var video = document.querySelector('#junior3VideoMp4');
		var btn = document.querySelector('#junior3VideoBtn')
		var wrap = document.querySelector('#junior3VideoWrap');
		btn.addEventListener('click', function () {
			wrap.classList.add('is-play');
			video.play();
			video.classList.add('is-active');
		});
		
	}
	
	initMvYoutube(){
		
		if(app.isSmartPhone()){
			this.videoMv = CrossCurricurum.VIDEO_MV_SP;
		}else{
			this.videoMv = CrossCurricurum.VIDEO_MV_PC;
		}
		
		var player = new YT.Player('mvVideo', {
			videoId: this.videoMv.id,
			autoplay: 1,
			controls: 0,
			modestbranding: 1,
			rel: 0,
			loop: 1,
			events: {
				'onReady': e =>{
					$(window).trigger('resize');
					e.target.mute();
					e.target.playVideo();
				},
				'onStateChange': e => {
					if(e.data == YT.PlayerState.ENDED){
						e.target.playVideo();
					}
					if(e.data == YT.PlayerState.PLAYING){
						document.getElementById('mvVideo').classList.add('is-ready');
					}
				}
			}
		});
		
		$(window).resize((e)=>{
			Youtube.cover('.cc-mv__video',this.videoMv.width ,this.videoMv.height);
		});
	}
	
	initLaboYoutube(){
		
		// var player = new YT.Player('laboVideo', {
		// 	videoId: CrossCurricurum.VIDEO_LABO_ID,
		// 	autoplay: 0,
		// 	controls: 0,
		// 	modestbranding: 1,
		// 	rel: 0,
		// 	events: {
		// 		'onReady': e =>{
		// 		},
		// 		'onStateChange': e => {
		// 			if(e.data == YT.PlayerState.ENDED){
		// 				e.target.playVideo();
		// 			}
		// 		}
		// 	}
		//	
		// });
		//
		// var btn = document.querySelector('#junior3VideoBtn')
		// var wrap = document.querySelector('#junior3VideoWrap');
		// btn.addEventListener('click', function () {
		// 	wrap.classList.add('is-play');
		// 	player.playVideo();
		// });
		//
		
	}
	
	initAnimation() {
		var images = document.querySelectorAll('[data-para]');
		new simpleParallax(images, {
			overflow: true,
			scale: 1.2
		});
		
	}
	
	initOpen() {
		$('._nav-link__head').click(e=>{
			$('._nav-link').toggleClass('is-open');
		});
		$('.cc-high6__head').click(e => {
			$(e.currentTarget).closest('.cc-high6__cource').toggleClass('is-open');
		});
		$('.cc-color2__btn').click(e => {
			$(e.currentTarget).closest('.cc-color2__project').toggleClass('is-open');
		});
		
	}
	
	initScroll() {
		$('._nav-link__link,.cc-nav__link').click(this.app.scroll);
		$('._nav-link__link').click(e=>{
			$('._nav-link').removeClass('is-open');
		});
	}
	
	initSlider() {
		
		var defaultOptions = {
			arrows: false,
			autoplay: true,
			autoplaySpeed: 1000,
			speed: 1000,
			cssEase: 'cubic-bezier(0.455, 0.030, 0.120, 0.975)',
		};
		
		if (this.app.isSmartPhone()) {
			var labSlick = $('.cc-junior2__items');
			labSlick.slick({
				arrows: false,
				autoplay: true,
				autoplaySpeed: 2000,
				speed: 1200,
				cssEase: 'cubic-bezier(0.455, 0.030, 0.120, 0.975)',
			});
			$('.cc-junior2 .slick-arr-l').click(e => {
				labSlick.slick('slickPrev');
			});
			$('.cc-junior2 .slick-arr-r').click(e => {
				labSlick.slick('slickNext');
			});
			
			var evetSlick = $('.cc-output2__item-imgs');
			evetSlick.slick(defaultOptions);
			
			var sdgsSlick = $('.cc-color2__main-img');
			sdgsSlick.slick(defaultOptions);
			
			var awardSlick = $('.cc-award3__list');
			awardSlick.slick(defaultOptions);
			$('.cc-award3 .slick-arr-l').click(e => {
				awardSlick.slick('slickPrev');
			});
			$('.cc-award3 .slick-arr-r').click(e => {
				awardSlick.slick('slickNext');
			});
		}else{
			
			var len = $('.cc-award3__item').length;
			if(len < 6){
				return;
			}
			var awardSlick = $('.cc-award3__list');
			awardSlick.css('display','block');
			awardSlick.slick({
				arrows: false,
				autoplay: true,
				autoplaySpeed: 1000,
				speed: 1000,
				slidesToShow: 5,
				centerMode: true,
				centerPadding: '0px',
				infinite: true,
				cssEase: 'cubic-bezier(0.455, 0.030, 0.120, 0.975)',
			});
			
		}
		
	}
}
